/*
 *
 * Signup constants
 *
 */

export const SIGNUP_CHANGE = 'src/Signup/SIGNUP_CHANGE';
export const SIGNUP_RESET = 'src/Signup/SIGNUP_RESET';
export const SET_SIGNUP_LOADING = 'src/Signup/SET_SIGNUP_LOADING';
export const SET_SIGNUP_SUBMITTING = 'src/Signup/SET_SIGNUP_SUBMITTING';
export const SET_SIGNUP_FORM_ERRORS = 'src/Signup/SET_SIGNUP_FORM_ERRORS';
export const SUBSCRIBE_CHANGE = 'src/Signup/SUBSCRIBE_CHANGE';
export const COMPARE_PASSWORD = 'src/Signup/COMPARE_PASSWORD';
export const ORGANIZER_SIGNUP_CHANGE = 'src/Signup/ORGANIZER_SIGNUP_CHANGE';
export const SET_OTP_MODAL = 'src/Signup/SET_OTP_MODAL';
export const OTP_CHANGE = 'src/Signup/OTP_CHANGE';
export const VERIFY_OTP = 'src/Signup/VERIFY_OTP';
export const SET_OTP_ERRORS = 'src/Signup/SET_OTP_ERRORS';
